import cn from 'classnames';
import Price from 'components/price';
import { PriceSummaryData } from 'modules/price-summary/types';
import { FC, ReactNode } from 'react';

interface Props {
  className?: string;
  summary: PriceSummaryData;
  title: ReactNode;
}

export const TotalRow: FC<Props> = ({ className, summary, title }) => {
  return (
    <div
      className={cn(
        className,
        'text-text-light-bg-primary flex items-center justify-between text-base font-black'
      )}
      data-test="total-section"
    >
      <span data-test="formatted-message-total">{title}</span>

      <span className="flex h-[30px] items-center text-xl" data-test="total-price">
        {summary.total === 0 ? (
          <span data-test="total-zero">-</span>
        ) : (
          <Price cents value={summary.total} />
        )}
      </span>
    </div>
  );
};
